import { Flex, Tab, TabsGroup } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { AttachmentFilterType } from '@features/attachments/enums/attachmentFiltertype'
import { UploadsTabType } from '@views/receipts/hooks/useReceiptsTabs'

interface UploadsTabsProps {
  tabs: UploadsTabType[]
  countMap: Record<string, number>
  isCountLoading: boolean
  selectedTab: AttachmentFilterType
  handleTabClick: (type: AttachmentFilterType) => () => void
}

export const UploadsTabs = ({
  tabs,
  selectedTab,
  handleTabClick,
  countMap,
  isCountLoading,
}: UploadsTabsProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Flex>
      <TabsGroup>
        {tabs.map((tab) => (
          <Tab
            key={tab.type}
            onClick={handleTabClick(tab.type)}
            active={selectedTab === tab.type}
            badgeCounter={
              isCountLoading || tab.type === AttachmentFilterType.Blocked || tab.type === AttachmentFilterType.Approved
                ? 0
                : countMap[tab.type]
            }
          >
            {t(tab.labelKey)}
          </Tab>
        ))}
      </TabsGroup>
    </Flex>
  )
}
